export default function initMoreToggle() {
    const elements = document.querySelectorAll('[data-more-toggle]');

    elements.forEach((element) => {
        element.addEventListener('click', (event) => {
            event.preventDefault();

            let targetRef = element.getAttribute('data-more-toggle');

            if (!targetRef)
                return;

            const target = document.querySelector(targetRef);

            if (!target)
                return;

            element.classList.toggle('is-open');
            target.classList.toggle('is-open');
        });
    });
}
